<template>
    <div>
        <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" class="mr-2" v-on="on">mdi-dots-vertical</v-icon>
            </template>
            <v-list class="py-0">
                <span v-for="(item, i) in items" :key="i">
                    <v-list-item  class="item" @click="meisterschaftAction(item)" :disabled="item.disabled ||
                                                        (item.disableIfEmpty && !bewerbExisting)">
                        <v-list-item-icon class="mr-3">
                            <v-icon>{{item.icon}}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title class="pr-3">{{ item.title }}</v-list-item-title>
                    </v-list-item>
                    <v-divider v-if="item.divider"></v-divider>
                </span>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
    export default {
        name: "meisterschaft-edit-menu",
        props: ['bewerbExisting'],
        data: () => ({
            items: [
                { title: 'Bewerb ändern', icon: 'mdi-pencil', action: 'editBewerb', disableIfEmpty: true },
                { title: 'Bewerb löschen', icon: 'mdi-trash-can-outline', action: 'deleteBewerb', divider: true, disableIfEmpty: true },
                { title: 'Meisterschaft ändern', icon: 'mdi-pencil', action: 'edit' },
                { title: 'Meisterschaft löschen', icon: 'mdi-trash-can-outline', action: 'delete' },
            ]
        }),
        methods: {
            meisterschaftAction(item){
                this.$emit('meisterschaftAction', item.action);
            },
        },
    }
</script>

<style scoped>
    .item:hover {background-color: #f2f2f2}
</style>